import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProductEventType } from '../shared/producteventtype.enum';
import { PRODUCT_EVENT_FORM_RULES } from './producteventform.config';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProductEventFormHelperService {
    private _storageTypeSub?: Subscription;

    applyFormRules(form: FormGroup, eventType: string | null): void {
        this._storageTypeSub?.unsubscribe();

        const config = eventType ? PRODUCT_EVENT_FORM_RULES[eventType] : null;

        if (!config) {
            Object.keys(form.controls).forEach((key) => form.get(key)?.enable());
            return;
        }

        if (config.values) {
            form.patchValue(config.values);
        }

        config.disabled?.forEach((key) => form.get(key)?.disable());

        config.enabled?.forEach((key) => form.get(key)?.enable());

        if (eventType === ProductEventType.SCRAPPED) {
            this._handleScrappedLogic(form);

            this._storageTypeSub = form.get('fromStorageType')?.valueChanges.subscribe(() => {
                this._handleScrappedLogic(form);
            });
        }
    }

    private _handleScrappedLogic(form: FormGroup): void {
        const partnerId = form.get('partnerId');
        const storageValue = form.get('fromStorageType')?.value;

        if (storageValue === 'PARTNER_WAREHOUSE') {
            partnerId?.enable();
        } else {
            partnerId?.disable();
            partnerId?.patchValue(null);
        }
    }
}
